// de/views/channelOta.js
export const channelOta = {
  common: {
    listing: "Inserat",
    back: "Zurück",
    close: "Schließen",
    cancel: "Abbrechen",
    flexible: "Flexibel",
    noResults: "Keine Treffer",
    deleteConn: "Verbindung löschen",
  },
  head: {
    manage: "{channel} verwalten",
    airbnbConfig: "Airbnb-Einstellungen",
    channelOptions: "Channel-Optionen",
  },
  picker: {
    placeholder: "Inserat suchen oder auswählen…",
  },
  loading: {
    status: "Channel-Status wird geladen…",
    listings: "Ihre Airbnb-Inserate werden geladen…",
    settings: "Einstellungen des Inserats werden geladen…",
  },
  accounts: {
    title: "Welches Ihrer {channel}-Konten?",
    lead: "Sie haben bereits ein {channel}-Konto verbunden. Sie können dieses Inserat dort hinzufügen oder ein anderes Konto verbinden. | Sie haben bereits {n} {channel}-Konten verbunden. Wählen Sie, zu welchem dieses Inserat gehört, oder verbinden Sie ein weiteres.",
    account: "Konto {n}",
    empty: "Noch keine Inserate",
    andMore: "{list} und {rest} weitere",
    newTitle: "Weiteres {channel}-Konto verbinden",
    newDesc: "Für Inserate, die zu einem anderen Konto gehören",
  },
  confirm: {
    title: "{channel}-Verbindung löschen",
    desc: "Der Channel wird aus dem channel manager und aus Ihren aktiven Verbindungen entfernt.",
    coversPre: "Diese Verbindung umfasst ",
    coversCount: "{count} Inserat | {count} Inserate",
    coversPost: " und wird von allen getrennt: {list}",
    purgePre: "Auch importierte Buchungen löschen? Wählen Sie, welche Zimmer ",
    purgeNote: "(sie können wiederhergestellt werden)",
    selectAll: "Alle",
    unselectAll: "Auswahl aufheben",
    delete: "Löschen",
    detachOnly: "Nur dieses Inserat trennen",
    deleteAll: "Löschen und {count} Inserat trennen | Löschen und alle {count} Inserate trennen",
    deleteWithResv: "Löschen (+{count} Buchung) | Löschen (+{count} Buchungen)",
  },
  gone: {
    title: "Diese Verbindung existiert im Channel nicht mehr",
    desc: "Der Channel wurde im channel manager gelöscht. Löschen Sie diese Verbindung, um sie über „Jetzt verbinden“ neu herzustellen.",
  },
  menu: {
    channelOptDesc: "Aktivieren oder pausieren, Zuordnung bearbeiten, synchronisieren, Buchungen abrufen oder die Verbindung löschen.",
    airbnbCfgDesc: "Check-in- und Check-out-Zeiten, Vorlaufzeit, Preise und Reinigung für jedes Inserat.",
  },
  channel: {
    statusLabel: "Channel-Status",
    active: "Aktiv",
    inactive: "Inaktiv",
    deactivate: "Channel deaktivieren",
    activate: "Channel aktivieren",
    pending: "In Prüfung",
    hintPending: "Der Kanal ist verbunden und hat deine Daten bereits. Er muss deine Unterkunft noch prüfen und annehmen; danach wird er von selbst aktiv. Das dauert meist ein paar Tage. Dauert es länger, schreib uns und wir sehen nach.",
    hintActive: "Der Channel ist aktiv: Wir senden Preise und Verfügbarkeit. Deaktivieren Sie ihn, um den Versand zu pausieren, ohne die Zuordnung zu verlieren.",
    blockersTitle: "Für die Aktivierung des Kanals fehlt noch etwas",
    blockersHint: "Klicke im Assistenten erneut auf „Verbinden“ – wir korrigieren es und senden erneut.",
    hintInactive: "Der Channel ist verbunden, aber pausiert. Aktivieren Sie ihn, um Preise und Verfügbarkeit zu senden.",
    editTitle: "Channel bearbeiten",
    editDesc: "Ändern oder ergänzen Sie die diesem Channel zugeordneten Zimmer und Tarife.",
    editBtn: "Zuordnung bearbeiten",
    fullSyncTitle: "Vollständige Synchronisierung",
    fullSyncDesc: "Sendet alle Preise, Verfügbarkeiten und Einschränkungen erneut an den Channel.",
    synced: "Synchronisiert",
    sync: "Synchronisieren",
    extractTitle: "Künftige Buchungen abrufen",
    extractDesc: "Importieren Sie die Buchungen, die Sie bereits im Channel haben, nach WACheckin.",
    imported: "Importiert",
    extract: "Abrufen",
    resyncTitle: "Buchungen erneut importieren",
    resyncDesc: "Ruft alle Buchungen des Channels erneut ab und ordnet sie mit der aktuellen Zuordnung neu zu. Nutzen Sie dies, wenn Sie das falsche Inserat gewählt haben oder Buchungen fehlen.",
    resync: "Erneut importieren",
  },
  cfg: {
    emptyNoListings: "Sie haben noch kein Inserat zugeordnet. Gehen Sie zu <b>Channel-Optionen → Zuordnung bearbeiten</b>, um Ihre Airbnb-Inserate mit Ihren Einheiten zu verbinden.",
    emptyNoMapping: "Für diese Unterkunft ist noch kein Airbnb-Inserat zugeordnet. Gehen Sie zu <b>Channel-Optionen → Zuordnung bearbeiten</b> und ordnen Sie das Inserat zu, um hier Zeiten und Preise festzulegen.",
  },
  arrival: {
    section: "An- und Abreise",
    lead: "Zu welchen Zeiten und an welchen Tagen Ihre Gäste ein- und auschecken können.",
    checkInFrom: "Check-in ab",
    checkInFromTip: "Früheste Uhrzeit, zu der ein Gast einchecken kann.",
    checkInTo: "Check-in bis",
    checkInToTip: "Späteste Uhrzeit, zu der ein Gast ankommen kann.",
    checkOut: "Check-out",
    checkOutTip: "Späteste Uhrzeit, zu der der Gast die Unterkunft verlassen muss.",
    unset: "Nicht festgelegt",
    daysIn: "Tage, an denen Check-in erlaubt ist",
    daysInTip: "Wochentage, an denen ein Gast einchecken kann.",
    daysOut: "Tage, an denen Check-out erlaubt ist",
    daysOutTip: "Wochentage, an denen ein Gast auschecken kann.",
  },
  booking: {
    section: "Buchungen",
    window: "Verfügbarkeitsfenster",
    windowTip: "Wie weit im Voraus Ihr Kalender für den Verkauf geöffnet ist. Airbnb nennt das „Verfügbarkeitsfenster“ (12 Monate = 365 Tage). Es ist NICHT die maximale Anzahl Nächte pro Aufenthalt.",
    minLead: "Mindestvorlaufzeit",
    minLeadTip: "Wie lange vor der Anreise noch gebucht werden kann. Verhindert Last-Minute-Buchungen.",
    maxStay: "Maximaler Aufenthalt",
    maxStayTip: "Maximale Anzahl Nächte pro Buchung. Bei Airbnb „maximale Nächte“, nicht zu verwechseln mit dem Verfügbarkeitsfenster.",
    turnover: "Tage zwischen Buchungen",
    turnoverTip: "Tage, die zwischen einem Check-out und dem nächsten Check-in blockiert werden, um zu reinigen und vorzubereiten.",
  },
  rules: {
    section: "Buchungsregeln",
    cancelPolicy: "Stornierungsbedingungen",
    cancelPolicyTip: "Wie viel der Gast bei einer Stornierung zurückerhält. Flexibel = kulanter, Streng = weniger Erstattung.",
    whoCanBook: "Wer buchen darf",
    whoCanBookTip: "Wer sofort buchen kann, ohne Ihre vorherige Zustimmung.",
  },
  prices: {
    section: "Preise",
    perNight: "Preis pro Nacht",
    weekend: "Wochenendpreis",
    weekendTip: "Preis für Freitag und Samstag. Lassen Sie ihn gleich dem Nachtpreis, wenn Sie keinen Unterschied möchten.",
    guestsIncluded: "Inbegriffene Gäste",
    guestsIncludedTip: "Anzahl der Gäste ohne Aufpreis.",
    extraGuest: "Preis pro zusätzlichem Gast",
    extraGuestTip: "Kosten pro zusätzlichem Gast und Nacht über die inbegriffenen hinaus.",
  },
  cleaning: {
    section: "Reinigung",
    notePre: "Füllen Sie beide Felder aus, damit jede Buchung die Reinigung bezahlt. Die Gebühr für Langzeitaufenthalte muss ",
    noteStrong: "gleich hoch oder höher",
    notePost: " sein als die für Kurzaufenthalte. Wenn Sie eine davon auf 0 lassen, zahlt diese Aufenthaltsart keine Reinigung.",
    long: "Reinigung · Langzeitaufenthalt",
    longTip: "Wird bei Langzeitaufenthalten berechnet. Muss gleich hoch oder höher sein als die Gebühr für Kurzaufenthalte.",
    short: "Reinigung · Kurzaufenthalt",
    shortTip: "Wird bei Kurzaufenthalten berechnet (wenige Nächte).",
    error: "Die Reinigungsgebühr für Langzeitaufenthalte ({sym}{long}) muss gleich hoch oder höher sein als die für Kurzaufenthalte ({sym}{short}).",
  },
  tax: {
    section: "Kurtaxe",
    lead: "Lokale Abgabe, die Sie dem Gast berechnen und selbst melden (nicht Airbnb). Lassen Sie den Wert auf 0, wenn sie nicht zutrifft.",
    amount: "Betrag",
    amountTip: "Höhe der Abgabe. 0 eingeben, um sie nicht anzuwenden.",
    charged: "Berechnung",
    chargedTip: "Wie die Abgabe berechnet wird: pro Gast und Nacht, pro Nacht oder pro Gast.",
    perGuestNight: "Pro Gast und Nacht",
    perNight: "Pro Nacht",
    perGuest: "Pro Gast",
    attestation: "Ich bestätige, dass diese Angaben korrekt sind und dass ich die Verantwortung für die Erhebung und Meldung dieser Abgabe übernehme.",
  },
  footer: {
    save: "Einstellungen speichern",
    saving: "Wird gespeichert…",
  },
  opts: {
    noticeNoLimit: "Ohne Begrenzung (alle Daten)",
    months: "{count} Monat | {count} Monate",
    maxNoLimit: "Ohne Begrenzung",
    nights: "{count} Nacht | {count} Nächte",
    maxNights: "Maximum ({count})",
    cancelModerate: "Moderat",
    cancelFirm: "Fest",
    cancelStrict: "Streng",
    instantEveryone: "Alle Gäste",
    instantWellReviewed: "Gut bewertete Gäste",
    instantVerified: "Verifizierte Identität",
    instantReviewedVerified: "Bewertungen + Identität",
    leadNone: "Keine Vorlaufzeit",
    hours: "{count} Stunde | {count} Stunden",
    days: "{count} Tag | {count} Tage",
  },
  msg: {
    loadSettingsError: "Die Einstellungen des Inserats konnten nicht geladen werden.",
    taxAttestationWarn: "Aktivieren Sie das Bestätigungsfeld, um die Kurtaxe anzuwenden.",
    saveOk: "Airbnb-Einstellungen gespeichert und an den Channel gesendet.",
    saveError: "Die Einstellungen konnten nicht gespeichert werden.",
    statusError: "Der Channel-Status konnte nicht geladen werden.",
    activated: "Channel aktiviert.",
    deactivated: "Channel deaktiviert.",
    toggleError: "Der Channel-Status konnte nicht geändert werden.",
    resyncOk: "Buchungen erneut importiert: {imported}.",
    resyncOkWarn: "Buchungen erneut importiert: {imported} ({errors} mit Warnung).",
    resyncError: "Die Buchungen konnten nicht erneut importiert werden.",
    disconnectError: "Die Verbindung konnte nicht gelöscht werden.",
    fullSyncOk: "Vollständige Synchronisierung gesendet.",
    extractOk: "Künftige Buchungen importiert.",
    actionError: "Die Aktion konnte nicht ausgeführt werden.",
  },
  rate: {
    apply: "Anwenden",
    or: "oder",
    usePlan: "einen Ihrer Tarife verwenden…",
  },
};
